import React from "react";
import { Link } from "react-router-dom";
import {
  FaDumbbell,
  FaUtensils,
  FaChartLine,
  FaCheckCircle,
  FaArrowRight,
} from "react-icons/fa";
import { motion } from "framer-motion";
import heroTransformation from "assets/before and after website.png";
import mealPlanImage from "assets/meal-plan.jpg";
import workoutPlanImage from "assets/exercise-plan.jpg";
import progressTrackingImage from "assets/progress-tracking-image.jpg";
import client1Before from "assets/client1-before.jpg";
import client1After from "assets/client1-after.jpg";
import client2Before from "assets/client2-before.jpg";
import client2After from "assets/client2-after.jpg";
import client3Before from "assets/client3-before.jpg";
import client3After from "assets/client3-after.jpg";

export const LandingPageComponent = () => {

  return (
    <div className="bg-white">
      {/* Hero Section */}
      <motion.div
        className="relative bg-black text-white"
        initial={{ opacity: 0, y: 100 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8 }}
      >
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-24">
          <div className="lg:grid lg:grid-cols-12 lg:gap-8">
            <motion.div
              className="lg:col-span-6"
              initial={{ opacity: 0, y: 100 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8, delay: 0.2 }}
            >
              <h1 className="text-4xl md:text-5xl font-extrabold tracking-tight mb-8">
                Transform Your Body.
                <br />
                Change Your Life.
                <br />
                {/* <span className="text-white">No More Skinny Guy Struggles.</span> */}
              </h1>
              <p className="text-lg text-gray-300 mb-8">
                Personalized meal plans and workout routines for muscle gain.
              </p>
              <div className="flex flex-col sm:flex-row gap-4">
                <Link
                  to="/register"
                  className="inline-flex items-center justify-center px-8 py-3 border border-transparent text-base font-medium rounded-md text-black bg-white hover:bg-gray-200 md:text-lg"
                >
                  Start Your Transformation
                  <FaArrowRight className="ml-2" />
                </Link>
                <a
                  href="#how-it-works"
                  className="inline-flex items-center justify-center px-8 py-3 border border-white text-base font-medium rounded-md text-white hover:text-gray-200 md:text-lg"
                >
                  Learn More
                </a>
              </div>
            </motion.div>
            <motion.div
              className="mt-12 lg:mt-0 lg:col-span-6"
              initial={{ opacity: 0, y: 100 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8, delay: 0.4 }}
            >
              <div className="relative">
                <img
                  src={heroTransformation}
                  alt="Physical transformation"
                  className="rounded-lg shadow-xl"
                />

              </div>
            </motion.div>
          </div>
        </div>
      </motion.div>

      {/* Trust Indicators */}
      <motion.div
        className="bg-gray-100 py-12"
        initial={{ opacity: 0, y: 50 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.8 }}
      >
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-8 text-center">
            <motion.div
              initial={{ opacity: 0, y: 50 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: 0 }}
            >
              <div className="text-4xl font-bold text-black">Multiple</div>
              <div className="text-gray-600">Successful Transformations</div>
            </motion.div>

            <motion.div
              initial={{ opacity: 0, y: 50 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: 0.1 }}
            >
              <div className="text-4xl font-bold text-black">12kg+</div>
              <div className="text-gray-600">Average Muscle Gain</div>
            </motion.div>

            <motion.div
              initial={{ opacity: 0, y: 50 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: 0.2 }}
            >
              <div className="text-4xl font-bold text-black">4.9/5</div>
              <div className="text-gray-600">Customer Satisfaction</div>
            </motion.div>

            <motion.div
              initial={{ opacity: 0, y: 50 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: 0.3 }}
            >
              <div className="text-4xl font-bold text-black">100%</div>
              <div className="text-gray-600">
                Money Back Guarantee
              </div>
            </motion.div>
          </div>
        </div>
      </motion.div>

      {/* Features Section */}
      <motion.div
        className="py-16 bg-white"
        id="how-it-works"
        initial={{ opacity: 0, y: 50 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.8 }}
      >
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-3xl font-extrabold text-black mb-8">
              How Does It Work?
            </h2>
            <h3 className="text-lg text-center mb-8 text-gray-700">
              Your dream body, in 3 simple and effective steps
            </h3>
          </div>
          <div className="flex flex-col gap-8">
            <motion.div
              className="flex flex-col lg:flex-row items-center gap-8"
              initial={{ opacity: 0, y: 50 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5 }}
            >
              <div className="w-full lg:w-1/2 lg:order-2">
                <div className="flex flex-col items-center mb-4">
                  <h1 className="text-4xl font-bold text-gray-700">1</h1>
                  <h2 className="text-2xl font-bold">
                    Personalized Meal Plans
                  </h2>
                </div>
                <p className="text-lg mb-4 text-gray-700">
                  Get delicious and easy-to-prepare recipes with foods you already love, so you never have to follow a strict diet again.
                </p>
              </div>
              <div className="w-full lg:w-1/2 lg:order-1">
                <img
                  src={mealPlanImage}
                  alt="Meal plan"
                  className="rounded-lg shadow-lg w-full"
                />
              </div>
            </motion.div>

            <motion.div
              className="flex flex-col lg:flex-row items-center gap-8"
              initial={{ opacity: 0, y: 50 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5 }}
            >
              <div className="w-full lg:w-1/2">
                <div className="flex flex-col items-center mb-4">
                  <h1 className="text-4xl font-bold text-gray-700">2</h1>
                  <h2 className="text-2xl font-bold">Workout Plans</h2>
                </div>
                <p className="text-lg mb-4 text-gray-700">
                  Only the exercises you need to reach your goal, designed to push you to your limits safely.
                </p>
              </div>
              <div className="w-full lg:w-1/2">
                <img
                  src={workoutPlanImage}
                  alt="Workout plan"
                  className="rounded-lg shadow-lg w-full"
                />
              </div>
            </motion.div>

            <motion.div
              className="flex flex-col lg:flex-row items-center gap-8"
              initial={{ opacity: 0, y: 50 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5 }}
            >
              <div className="w-full lg:w-1/2 lg:order-2">
                <div className="flex flex-col items-center mb-4">
                  <h1 className="text-4xl font-bold text-gray-700">3</h1>
                  <h2 className="text-2xl font-bold">Progress Tracking</h2>
                </div>
                <p className="text-lg mb-4 text-gray-700">
                  Build good habits and visualize your progress for endless motivation.
                </p>
              </div>
              <div className="w-full lg:w-1/2 lg:order-1">
                <img
                  src={progressTrackingImage}
                  alt="Progress tracking"
                  className="rounded-lg shadow-lg w-full"
                />
              </div>
            </motion.div>
          </div>
        </div>
      </motion.div>

      {/* Testimonials Section */}
      <motion.div
        className="py-16 bg-white overflow-hidden"
        initial={{ opacity: 0, y: 50 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.8 }}
      >
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="text-3xl font-extrabold text-center text-black mb-8">
            Real Transformations
          </h2>
          <h3 className="text-lg text-center mb-8 text-gray-700">
            Real results from people who took action
          </h3>
          <div className="flex overflow-x-auto pb-8 gap-8 snap-x snap-mandatory">
            <motion.div
              className="flex-none w-[80vw] md:w-[600px] snap-center"
              initial={{ opacity: 0, y: 50 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: 0.2 }}
            >
              <div className="bg-white p-6 rounded-lg border border-black h-full">
                <div className="flex items-center mb-6">
                  <h4 className="font-bold text-xl">Brandon N.</h4>
                  <div className="ml-4 text-gray-600">
                    {/* <span>Age: 25 • </span> */}
                    <span className="font-semibold text-black">
                      +8kg in 6 months
                    </span>
                  </div>
                </div>

                <div className="flex gap-4 mb-6">
                  <div className="w-1/2 relative">
                    <img
                      src={client1Before}
                      alt="Brandon N. before"
                      className="w-full h-[300px] object-cover rounded-lg"
                    />
                    <span className="absolute bottom-2 left-2 bg-black text-white px-3 py-1 rounded">
                      Before
                    </span>
                  </div>
                  <div className="w-1/2 relative">
                    <img
                      src={client1After}
                      alt="Brandon N. after"
                      className="w-full h-[300px] object-cover rounded-lg"
                    />
                    <span className="absolute bottom-2 left-2 bg-black text-white px-3 py-1 rounded">
                      After
                    </span>
                  </div>
                </div>

                <p className="text-black text-lg italic">
                  "I finally managed to build muscle consistently and sustainably. The program is easy to follow and the results are there!"
                </p>
              </div>
            </motion.div>

            <motion.div
              className="flex-none w-[80vw] md:w-[600px] snap-center"
              initial={{ opacity: 0, y: 50 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: 0.4 }}
            >
              <div className="bg-white p-6 rounded-lg border border-black h-full">
                <div className="flex items-center mb-6">
                  <h4 className="font-bold text-xl">Abubakar B.</h4>
                  <div className="ml-4 text-gray-600">
                    {/* <span>Age: 28 • </span> */}
                    <span className="font-semibold text-black">
                      +12kg in 8 months
                    </span>
                  </div>
                </div>

                <div className="flex gap-4 mb-6">
                  <div className="w-1/2 relative">
                    <img
                      src={client2Before}
                      alt="Abubakar B. before"
                      className="w-full h-[300px] object-cover rounded-lg"
                    />
                    <span className="absolute bottom-2 left-2 bg-black text-white px-3 py-1 rounded">
                      Before
                    </span>
                  </div>
                  <div className="w-1/2 relative">
                    <img
                      src={client2After}
                      alt="Abubakar B. after"
                      className="w-full h-[300px] object-cover rounded-lg"
                    />
                    <span className="absolute bottom-2 left-2 bg-black text-white px-3 py-1 rounded">
                      After
                    </span>
                  </div>
                </div>

                <p className="text-black text-lg italic">
                  "The personalized tracking and adapted nutrition plans made all the difference. I didn't think I could achieve these results!"
                </p>
              </div>
            </motion.div>

            <motion.div
              className="flex-none w-[80vw] md:w-[600px] snap-center"
              initial={{ opacity: 0, y: 50 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: 0.6 }}
            >
              <div className="bg-white p-6 rounded-lg border border-black h-full">
                <div className="flex items-center mb-6">
                  <h4 className="font-bold text-xl">You Y.</h4>
                  <div className="ml-4 text-gray-600">
                    {/* <span>Age: X • </span> */}
                    <span className="font-semibold text-black">
                      +Xkg in X months
                    </span>
                  </div>
                </div>

                <div className="flex gap-4 mb-6">
                  <div className="w-1/2 relative">
                    <img
                      src={client3Before}
                      alt="You Y. before"
                      className="w-full h-[300px] object-cover rounded-lg"
                    />
                    <span className="absolute bottom-2 left-2 bg-black text-white px-3 py-1 rounded">
                      Before
                    </span>
                  </div>
                  <div className="w-1/2 relative">
                    <img
                      src={client3After}
                      alt="You Y. after"
                      className="w-full h-[300px] object-cover rounded-lg"
                    />
                    <span className="absolute bottom-2 left-2 bg-black text-white px-3 py-1 rounded">
                      After
                    </span>
                  </div>
                </div>

                <p className="text-black text-lg italic">
                  "Your transformation story starts here!"
                </p>
              </div>
            </motion.div>
          </div>
        </div>
      </motion.div>

      {/* CTA Section */}
      <motion.div
        className="bg-black text-white py-16"
        initial={{ opacity: 0, y: 50 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.8 }}
      >
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-3xl font-extrabold mb-8">
            Ready to Transform Your Body?
          </h2>
          <p className="text-xl mb-8 max-w-2xl mx-auto">
            Join hundreds of guys who have already transformed their bodies with our proven system.
          </p>
          <div className="flex flex-col sm:flex-row justify-center gap-4">
            <Link
              to="/register"
              className="inline-flex items-center justify-center px-8 py-3 border border-transparent text-base font-medium rounded-md text-black bg-white hover:bg-gray-200 md:text-lg"
            >
              Start Your Journey
              <FaArrowRight className="ml-2" />
            </Link>
            <Link
              to="/testimonials"
              className="inline-flex items-center justify-center px-8 py-3 border-2 border-white text-base font-medium rounded-md text-white hover:bg-gray-900 md:text-lg"
            >
              See More Results
            </Link>
          </div>
        </div>
      </motion.div>
    </div>
  );
};
